/**
 * 提交表单
 */
import * as React from 'react'
import { useRouter } from 'next/router'
import { Input, Form, message, Typography } from 'antd'
import copy from 'copy-text-to-clipboard'
import { useTranslation, dynamicTrans } from '@/libs/next-lang'
import { userCaptchaSend, checkValidate, businessInfoAdd } from '@/services/common'
import CountDown from '@/components/CountDown'
import Captcha from '@/components/Captcha'
import usePageType, { PAGE_TYPES } from '@/hooks/usePageType'
import gioTrackEvent from '@/utils/gio'
import styles from './index.module.less'

const phoneReg = /^((0\d{2,3}-\d{7,8})|(1[3584796]\d{9}))$/
const codeReg = /^[0-9]{4}$/

const FormItem = Form.Item
const { Paragraph } = Typography

const { useState, useRef } = React

export default function Content({ hideModal }: any) {
  const router = useRouter()
  const { channel }: any = router.query || {}
  const [loaded, setLoaded] = useState(false)
  // const [done, setDone] = useState(false);
  const captchaInsRef = useRef<any>(null)
  const confirmRef = useRef<boolean>(false)
  const validateRef = useRef<boolean>(false)
  const [form] = Form.useForm()
  const pageType = usePageType()

  const { t } = useTranslation(['components'])

  let website: string = 'www.creativebooster.com'

  const ch: any = ((channel as any) || '').toLowerCase()
  if (ch === 'google') {
    // 跳转广告主
    website = 'gg.creativebooster.com'
  }

  /**
   *
   * @param params
   * @returns
   */
  const validateVerify = async (params: any = {}) => {
    let checkValidateResult = validateRef.current
    try {
      const { data = {} } = await checkValidate(params || {})
      if (data?.code === 0) {
        // 切换成登录框
        checkValidateResult = data.result
      }
    } catch (e) {
      console.error('滑块验证码捕获错误: ', e)
      checkValidateResult = false
      confirmRef.current = false
    }
    validateRef.current = checkValidateResult
    return checkValidateResult
  }

  /**
   * 发送验证码
   * @param e
   */
  const handleSend = async (e: any, start: () => void) => {
    e.stopPropagation()
    const { username } = await form.validateFields(['username'])
    if (phoneReg.test(username || '')) {
      message.destroy()
      // 手机号校验通过
      try {
        // 滑块校验
        const { validate } = await captchaInsRef.current?.verify()
        start?.()
        const { data = {} } = await userCaptchaSend({
          phone: username,
          sendType: 'CODE_VERIFICATION',
          validate,
        })
        if (data && data.code === 0) {
          // 埋点
          if (PAGE_TYPES.EDM_EC === pageType) {
            gioTrackEvent('EDM_EC_Landingpage_bonus_Vcode_click')
          } else if (PAGE_TYPES.EDM_GAME === pageType) {
            gioTrackEvent('EDM_Game_Landing_bonus_Vcode_click')
          } else if (PAGE_TYPES.EDM_APP === pageType) {
            gioTrackEvent('EDM_APP_Landingpage_bonus_Vcode_click')
          } else if (PAGE_TYPES.EDM_GENERAL === pageType) {
            gioTrackEvent('EDM_general_Landingpage_bonus_Vcode_click')
          } else if (PAGE_TYPES.WECHAT_GENERAL === pageType) {
            gioTrackEvent('Wechat_general_Landingpage_bonus_Vcode_click')
          }
          message.success(t('components:t44'))
          process.env.NODE_ENV !== 'production' &&
            data.result &&
            form.setFieldsValue({ captcha: data.result })
        }
      } catch (err) {
        console.error('发送验证码失败: ', err)
      }
    } else {
      message.warning(t('components:t130'))
    }
  }

  /**
   * 提交句柄
   * @param params
   * @returns
   */
  const handleSubmit = async (params: any) => {
    message.destroy()
    try {
      const { data = {} } = await businessInfoAdd(params)
      if (data?.code === 0) {
        const { id } = data?.result || {}
        message.success(t('components:t131'))
        hideModal()
        if (id) {
          window?.gio?.('setUserId', `${id}`)
          window?.gio?.('people.set', {
            phone: data?.result.phone,
            email: data?.result.email,
            source: pageType,
          })
        }

        // 埋点
        if (PAGE_TYPES.EDM_EC === pageType) {
          gioTrackEvent('EDM_EC_Landingpage_bonus_successpageview')
        } else if (PAGE_TYPES.EDM_GAME === pageType) {
          gioTrackEvent('EDM_Game_Landing_bonus_successpageview')
        } else if (PAGE_TYPES.EDM_APP === pageType) {
          gioTrackEvent('EDM_APP_Landingpage_bonus_successpageview')
        } else if (PAGE_TYPES.EDM_GENERAL === pageType) {
          gioTrackEvent('EDM_general_Landingpage_bonus_successpageview')
        } else if (PAGE_TYPES.WECHAT_GENERAL === pageType) {
          gioTrackEvent('Wechat_general_Landingpage_bonus_successpageview')
        }
      }
    } catch (e: any) {
      if (e?.message) {
        message.error(e.message)
      }
      console.error('一键询价失败: ', e)
    } finally {
      confirmRef.current = false
    }
  }

  /**
   * 点击
   */
  const handleReceive = () => {
    form.validateFields().then(async (values: any) => {
      message.destroy()
      const { username, captcha, description } = values
      if (!phoneReg.test(username) || !codeReg.test(captcha)) {
        return message.warning(t('components:t132'))
      }
      if (!description) {
        return message.warning(t('components:t133'))
      }
      if (confirmRef.current) {
        // 正在提交
        return
      }
      confirmRef.current = true
      // 提交参数
      const params: any = {
        account: username,
        language: 'CHINESE',
        captcha,
        description,
      }
      if (channel) {
        // EDM(EDM推广)、 SINO_PUBLIC(SINO 公众号)、BEYOND_CLICK_PUBLIC(Beyondclick飞书点跃公众号)
        params.origin = channel
      }
      // 判断提交时是否需要滑块验证
      const isValidate = await validateVerify()
      if (isValidate) {
        try {
          const { validate } = await captchaInsRef.current.verify()
          params.validate = validate
          if (validate) {
            await handleSubmit(params)
          }
        } catch (error: any) {
          confirmRef.current = false
          console.error('一键询价失败: ', error)
        }
      } else {
        await handleSubmit(params)
      }
    })
  }

  /**
   * 复制文本
   * @param val
   * @returns
   */
  const handleCopy = () => {
    message.destroy()
    message.success(t('components:t134'))
    copy(website)
  }

  const renderSuffix = () => {
    return (
      <CountDown
        seconds={60}
        render={(onStart, disabled, current) => {
          if (disabled) {
            const txt = dynamicTrans(t('components:t55'), { second: `${current || 60}s` })
            return (
              <div className={`${styles.suffix} ${styles.disabled}`}>
                {`| ${txt}`}
              </div>
            )
          }
          return (
            <div className={styles.suffix} onClick={(e: any) => handleSend(e, onStart)}>
              | {t('components:t56')}
            </div>
          )
        }}
      />
    )
  }

  const handleChange = (e: any) => {
    const { value: inputValue } = e.target
    form.setFieldsValue({
      username: inputValue.replace(/[^\d]/g, ''),
    })
  }

  const renderForm = () => {
    return (
      <>
        <img
          draggable={false}
          className={styles.img}
          src="https://static.creativebooster.com/landing/gtm/gift_bg_m.png?x-oss-process=imageformat,webp"
          alt="receive"
          onLoad={() => setLoaded(true)}
        />
        {loaded && (
          <div className={styles.main}>
            <div className={styles.content}>
              <h3 className={styles.title}>{t('components:t135')}</h3>
            </div>
            <div className={styles.form}>
              <Form form={form}>
                <FormItem name="username" noStyle>
                  <Input
                    className={styles.input}
                    placeholder={t('components:t136')}
                    suffix={renderSuffix()}
                    onChange={handleChange}
                  />
                </FormItem>
                <FormItem name="captcha" noStyle>
                  <Input className={styles.input} placeholder={t('components:t137')} pattern="[0-9]*" />
                </FormItem>
                <FormItem name="description" noStyle>
                  <Input.TextArea
                    maxLength={100}
                    className={styles.textArea}
                    placeholder={t('components:t138')}
                  />
                </FormItem>
                <div className={styles.btn} onClick={handleReceive}>
                  {t('components:t139')}
                </div>
              </Form>
            </div>
          </div>
        )}
        <Captcha ref={captchaInsRef} />
      </>
    )
  }
  return <div className={styles.gift}>{renderForm()}</div>
}
